<template>
    <div>
        <v-row>
            <v-col>
                <strong>Level: </strong> {{work['level']}}
            </v-col>
            <v-col>
                <strong>Country: </strong> {{countryMap[work['nationality']]}}
            </v-col>
            <v-col>
                <strong>Sex: </strong> {{sexMap[work['sex']]}}
            </v-col>
            <v-col>
                <strong>Age: </strong> {{work['age']}}
            </v-col>
            <v-col>
                <strong>Author (ID): </strong> {{work['anon_author']}}
            </v-col>
            <v-col>
                <strong>Word count (estimated): </strong> {{work['word_count']}}
            </v-col>
    
    
        </v-row>
        <v-row v-if="sideBySide">
            <v-col cols='6' class="diffText" id="diffLeft">
                <h2>ข้อความต้นฉบับ</h2>
                <span v-html="answerDiff">
                    </span>
            </v-col>
            <v-col cols='6' class="diffText" id="diffRight">
                <h2>ข้อความที่แก้ไขแล้ว</h2>
                <span v-html="answerDiff">
                    </span>
            </v-col>
        </v-row>
        <v-row v-else>
        </v-row>
    </div>
</template>

<style lang="scss">
.diffText {
    background: #fff;
    font-size: 1.1em;
    h2 {
        margin-bottom: 0.5em;
    }
}

#diffLeft {
    del {
        text-decoration: none;
        background: none;
    }
    ins {
        display: none;
    }
}

#diffRight {
    del {
        background: #6b1717;
        color: white;
    }
    ins {
        background: #28852c;
        color: white;
    }
}
</style>

<script>
import { mapState } from 'vuex'
var Diff = require('text-diff')

var _countryMap = require('@/assets/countrymap.json')

export default {
    name: 'individualWork',
    props: ['id'],
    data: () => ({
        sideBySide: true,
        countryMap: _countryMap
    }),
    computed: {
        work: function() {
            return this.corpus[this.id]
        },
        answerDiff: function() {
            let diff = new Diff()
            if (this.corpus[this.id] !== undefined) {
                // console.log('triggered')
                const textdiff = diff.main(this.corpus[this.id]['answer0'], this.corpus[this.id]['answer1'])
                return diff.prettyHtml(textdiff)
            } else {
                return ''
            }
        },
        ...mapState({
            corpus: state => state.corpus,
            // countryMap: state => state.countryMap,
            sexMap: state => state.sexMap
        })
    }
}
</script>